export const REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FORM_INVALID_EMAIL_KEY =
  'RequestProfile.ProvidersInvalidWorkerEmailKey'

export const REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FORM_VALID_EMAIL_TEST_NAME =
  'valid-side-worker-email'

export const REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FORM_NO_INVALID_INPUT_TEST_NAME =
  'side-workers-no-invalid-input'
